const firebaseEnv = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  themeCollection:
    process.env.REACT_APP_FIREBASE_THEME_COLLECTION || "portfolioThemes",
  contactCollection:
    process.env.REACT_APP_FIREBASE_CONTACT_COLLECTION || "portfolioMessages",
  themeDocId: process.env.REACT_APP_FIREBASE_THEME_DOC_ID || "defaultTheme",
};

export const isFirebaseConfigured = () =>
  Boolean(firebaseEnv.apiKey && firebaseEnv.projectId);

const getBaseUrl = () =>
  `https://firestore.googleapis.com/v1/projects/${firebaseEnv.projectId}/databases/(default)/documents`;

const toFirestoreValue = (value) => {
  if (value === null || value === undefined) {
    return { nullValue: null };
  }

  if (Array.isArray(value)) {
    return {
      arrayValue: {
        values: value.map((item) => toFirestoreValue(item)),
      },
    };
  }

  if (typeof value === "boolean") {
    return { booleanValue: value };
  }

  if (typeof value === "number") {
    return Number.isInteger(value)
      ? { integerValue: String(value) }
      : { doubleValue: value };
  }

  if (typeof value === "object") {
    return {
      mapValue: {
        fields: Object.entries(value).reduce((acc, [key, nestedValue]) => {
          acc[key] = toFirestoreValue(nestedValue);
          return acc;
        }, {}),
      },
    };
  }

  return { stringValue: String(value) };
};

const toFirestoreFields = (data) =>
  Object.entries(data).reduce((acc, [key, value]) => {
    acc[key] = toFirestoreValue(value);
    return acc;
  }, {});

export const saveThemePreferenceRemote = async (payload) => {
  if (!isFirebaseConfigured()) {
    return { skipped: true, reason: "firebase-not-configured" };
  }

  const response = await fetch(
    `${getBaseUrl()}/${firebaseEnv.themeCollection}/${firebaseEnv.themeDocId}?key=${firebaseEnv.apiKey}`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fields: toFirestoreFields(payload),
      }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to save theme preferences to Firebase.");
  }

  return response.json();
};

export const saveContactMessageRemote = async (payload) => {
  if (!isFirebaseConfigured()) {
    return { skipped: true, reason: "firebase-not-configured" };
  }

  const response = await fetch(
    `${getBaseUrl()}/${firebaseEnv.contactCollection}?key=${firebaseEnv.apiKey}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fields: toFirestoreFields(payload),
      }),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to submit contact message to Firebase.");
  }

  return response.json();
};
